<template>
    <div class="clearfix">
        <router-link
            class="kt-nav__link m-2 btn btn-outline-primary float-right" :to="{ name:'add_verified_company'}">
            {{ $t('deposit.add_company') }}
        </router-link>
        <kt-row style="margin-top: 70px" v-if="verified_companies_status == 'success'">
            <div id="all_verified_companies" class="col-sm-12 col-lg-4 col-md-4" v-for="company in verified_companies"
                 v-bind:key="company.id">
                <kt-panel class="shadow">
                    <kt-panel-body>
                        <kt-panel-header-label class="text-center" style=";z-index: 1;">
                            <kt-panel-header-title style="" class="mt-3 text-dark">
                                <div class="mb-2" style="font-size: 1.5rem">
                                    {{ company.title }}
                                </div>
                            </kt-panel-header-title>
                        </kt-panel-header-label>
                        <kt-row>
                         <div style="padding: 0 10px;border-radius: 5px" v-if="company.status" class="offset-5 badge-success text-white" >
                             {{ $t('label.active') }}
                         </div>
                            <div style="padding: 0 10px;border-radius: 5px" v-else class="offset-5 badge-danger text-white" >
                             {{ $t('label.inactive') }}
                         </div>
                        </kt-row>
                    </kt-panel-body>
                    <kt-row>
                        <kt-col>
                            <kt-panel-footer class="p-2 text-center">
                                <router-link
                                    class="btn btn-secondary border-0 w-100 bg-secondary text-dark btn-square"
                                    :to="{name:'verified_company_details', params : {hashid: company.id, gateway_source: gatewaySource}}"
                                >
                                    {{ $t('btn.edit') }}
                                </router-link>
                            </kt-panel-footer>
                        </kt-col>
                        <kt-col>
                            <kt-panel-footer class="p-2 text-center">
                                <kt-button
                                    class="btn btn-secondary border-0 w-100 bg-secondary text-dark btn-square"
                                    @click="deleteCompany(company.id)"
                                    :id="'delete_btn_' + company.id"
                                >
                                    {{ $t('btn.delete') }}
                                </kt-button>
                            </kt-panel-footer>
                        </kt-col>
                    </kt-row>

                </kt-panel>
            </div>
        </kt-row>
    </div>
</template>

<script>
import {mapGetters} from "vuex";
import { depositPfService, depositStarshopService } from "@/common/api.service"
import {KTApp} from '@/plugins/core/app';
import $ from "jquery";
import {i18n} from "@/plugins/i18n";
import toastr from 'toastr'
import {pspList} from '@/constants/psp'


export default {
    components: {},
    data() {
        return {
            pspList,
            headerAction: {
                left: '10px',
                top: '10px',
                position: 'absolute'
            },
            depositPfService,
            depositStarshopService
        }
    },
    computed: {
        gatewaySource() {
            return this.$route.params.gateway_source;
        },
        apiService() {
            return this.$route.params.gateway_source === 'pf' ? this.depositPfService : this.depositStarshopService;
        },
        ...mapGetters('deposit', [
            'verified_companies',
            'verified_companies_status',
        ]),
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: "toast-bottom-center",
                preventDuplicates: false,
                rtl: false
            }

            return toastr
        }
    },
    methods: {
        deleteCompany(hashid) {
            if (confirm(i18n.t('deposit.message.confirm_delete_company'))) {
                let btn = $('#delete_btn_' + hashid)
                KTApp.progress(btn)
                this.apiService.deleteVerifiedCompany(hashid).then(response => {
                    this.$store.dispatch('deposit/fetchVerifiedCompanies')
                    return this.toastr.success(response.data.message)
                }).catch(({response}) => {
                    return this.toastr.error(response.data.message)
                }).finally(() => {
                    KTApp.unprogress(btn)
                })
            }
        }
    },
    mounted() {
        this.$store.dispatch('deposit/fetchVerifiedCompanies', this.gatewaySource === 'starshop')
    }
}
</script>

<style>

</style>